import React from 'react';
import { Box, Typography, Paper, Grid, Card, CardContent, Button, TextField } from '@mui/material';
import { Assessment, Download, TrendingUp, AccountBalance, Receipt, Pix } from '@mui/icons-material';

const ReportsPage: React.FC = () => {
  const stats = [
    { title: 'Total Recebido', value: 'R$ 125.430,00', icon: <TrendingUp color="success" />, period: 'Este mês' },
    { title: 'Total Transferido', value: 'R$ 89.150,00', icon: <AccountBalance color="primary" />, period: 'Este mês' },
    { title: 'Boletos Emitidos', value: '156', icon: <Receipt color="warning" />, period: 'Este mês' },
    { title: 'Transações PIX', value: '342', icon: <Pix color="success" />, period: 'Este mês' },
  ];

  const reportTypes = [
    { title: 'Relatório de Transações', description: 'Todas as movimentações da conta', format: 'PDF / Excel' },
    { title: 'Relatório de PIX', description: 'Transferências PIX enviadas e recebidas', format: 'PDF / Excel' },
    { title: 'Relatório de Boletos', description: 'Boletos emitidos, pagos e vencidos', format: 'PDF / Excel' },
    { title: 'Relatório Financeiro', description: 'Resumo financeiro consolidado', format: 'PDF / Excel' },
  ];

  return (
    <Box>
      <Typography variant="h5" fontWeight="bold" sx={{ mb: 3 }}>
        <Assessment sx={{ mr: 1, verticalAlign: 'middle' }} />
        Relatórios
      </Typography>

      <Grid container spacing={3} sx={{ mb: 4 }}>
        {stats.map((stat, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card>
              <CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <Box>
                    <Typography color="text.secondary" variant="body2">{stat.title}</Typography>
                    <Typography variant="h5" fontWeight="bold">{stat.value}</Typography>
                    <Typography variant="caption" color="text.secondary">{stat.period}</Typography>
                  </Box>
                  {stat.icon}
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2 }}>
          Período do Relatório
        </Typography>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={4}>
            <TextField fullWidth label="Data Início" type="date" InputLabelProps={{ shrink: true }} />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField fullWidth label="Data Fim" type="date" InputLabelProps={{ shrink: true }} />
          </Grid>
        </Grid>
      </Paper>

      <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2 }}>
        Tipos de Relatório
      </Typography>
      <Grid container spacing={2}>
        {reportTypes.map((report, index) => (
          <Grid item xs={12} sm={6} key={index}>
            <Paper sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Box>
                <Typography fontWeight="bold">{report.title}</Typography>
                <Typography variant="body2" color="text.secondary">{report.description}</Typography>
                <Typography variant="caption" color="text.secondary">Formato: {report.format}</Typography>
              </Box>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Button variant="outlined" size="small" startIcon={<Download />}>PDF</Button>
                <Button variant="outlined" size="small" startIcon={<Download />}>Excel</Button>
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ReportsPage;
